import appSpecificSubdomains from "./appSpecificSubdomains";

export default window.origin.includes(`/${appSpecificSubdomains.app}.`);
